import React from "react";
import PropTypes from "prop-types";
import { Alert } from "reactstrap";

const propTypes = {
  daysRemaining: PropTypes.number
};

const AwaitingConfigurationAlert = ({ daysRemaining = null }) => (
  <Alert color="warning" className="mt-0 mb-2 p-2">
    <small className="d-flex align-items-center">
      <i className="fa fa-regular fa-clock mr-2" />
      <span>
        <strong>{daysRemaining ?? 60} days</strong> remaining to finish and launch
      </span>
    </small>
  </Alert>
);

AwaitingConfigurationAlert.propTypes = propTypes;

export default AwaitingConfigurationAlert;
